export const STARTER_MIGRATION_DATE = 'January 6, 2025';
export const MEDIUM_LICENSE_MIGRATION_DATE = 'January 15, 2025';
export const BIG_LICENSE_MIGRATION_DATE = 'February 2, 2025';
